<template lang="pug">
  .it-closing-info-audit
    final-report(
     :data="subFinalScope"
     is-hidden
   )
    el-row(style="margin-left: 20px")
      el-col(:span="4" style="font-weight: 500;") {{ $t('完成情况') }}
      el-col(:span="20")
        kpi-situation(
          :viewData="subFinalScope.kpi"
          :isEdit="false"
        )

    quotation-info(
      :tableData="tableData"
      :quotationDetail="quotationDetail"
      :isBeyond="isBeyond"
    )

    template(v-if="marketRes.status !== null || LV3Res.status !== null")
      title-bar {{ $t('市场部审核结果') }}
      div(style="margin-left: 20px")
        market-audit-result(
          :hasMarket="marketRes.status !== null"
          :hasLv3="isNeedLv3Approve"
          :market="marketRes"
          :lv3="LV3Res"
        )

    title-bar {{ $t('IT审核') }}
    div(style="margin-left: 20px")
      marketing-audit(
        :auditData="auditData"
        ref="audit"
      )

    el-row(style="margin-left: 20px")
      el-col(
        :span="20"
        :offset="4"
      )
        footer-button(
          v-if="!isView"
          @confirm="submit"
          @cancel="$router.push('/campaign/process')"
        )
    audit-versions(
      :id="subFinalScopeId"
      :businessType="$store.state.campaign.businessType"
      :auditType="11"
    )
</template>

<script>
import FinalReport from '@/components/FinalReport'
import KpiSituation from '@/components/KpiSituation'
import QuotationInfo from '@/components/QuotationInfo'
import TitleBar from '@/components/TitleBar'
import MarketingAudit from '@/components/MarketingAudit'
import MarketAuditResult from '@/components/MarketAuditResult'
import FooterButton from '@/components/FooterButton'
import ProcurementAuditView from '@/components/ProcurementAuditView'
import axios from 'axios'
import AuditVersions from '@/components/AuditVersions'

const getCompletedProgress = subFinalScopeId => {
  return axios.get('/management/subfinal/getCompletedProgress', {
    params: {
      sub_final_scope_id: subFinalScopeId
    }
  })
}

const getVendorQuotation = (id, activePhaseType, phaseType) => {
  return axios.get('/management/subfinal/getVendorQuotation', {
    params: {
      sub_final_scope_vendor_id: id,
      phase_current: activePhaseType,
      phase_reality: phaseType
    }
  })
}

const approveFinalReport = params => {
  return axios.get('/management/subfinal/approveFinalReport', {params})
}

const getApproveResult = params => {
  return axios.get('/management/subfinal/getApproveResult', {params})
}

const fetchContact = campaignID => {
  return axios.get('/management/subfinal/getContactInfo', {
    params: {
      campaign_id: campaignID
    }
  })
}

const getVendorPriceOverview = id => {
  return axios.get('/management/subfinal/getVendorPriceOverview', {
    params: {
      sub_final_scope_vendor_id: id
    }
  })
}

const checkNeedLv3Approve = id => {
  return axios.get('/management/subfinal/checkNeedLv3Approve', {
    params: {
      sub_final_scope_id: id
    }
  })
}

export default {
  components: {
    FinalReport,
    QuotationInfo,
    TitleBar,
    MarketingAudit,
    FooterButton,
    ProcurementAuditView,
    KpiSituation,
    AuditVersions,
    MarketAuditResult
  },
  data () {
    return {
      visible: false,
      isBeyond: false,
      auditData: {
        result: 1,
        remark: null
      },
      subFinalScope: {
        sub_final_scope_name: null,
        approve_result: {}
      },
      cc: '',
      contact: {},
      tableData: {},
      LV3Res: {},
      marketRes: {},
      quotationDetail: [],
      isNeedLv3Approve: true
    }
  },
  computed: {
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    campaignID () {
      return this.$store.state.campaign.id
    },
    campaign () {
      return this.$store.state.campaign
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    }
  },
  mounted () {
    this.fetchData()
    if (this.isView) {
      this.getITApproveResult()
    }
  },
  methods: {
    async fetchData () {
      const loading = this.$loading()

      try {
        this.subFinalScope = await getCompletedProgress(this.subFinalScopeId)
        const [tableData, contact, marketRes, LV3Res, isNeedLv3Approve] = await Promise.all([
          getVendorPriceOverview(this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id),
          fetchContact(this.campaignID),
          getApproveResult({
            id: this.subFinalScopeId,
            business_type: this.campaign.businessType,
            audit_type: 7
          }),
          getApproveResult({
            id: this.subFinalScopeId,
            business_type: this.campaign.businessType,
            audit_type: 8
          }),
          checkNeedLv3Approve(this.campaign.subFinalScopeId)
        ])

        this.tableData = tableData
        this.contact = contact
        this.marketRes = marketRes
        this.LV3Res = LV3Res
        this.isNeedLv3Approve = isNeedLv3Approve.is_need_marketing_lv3
        this.isBeyond = this.subFinalScope.quotation_increased

        const quotation = await getVendorQuotation(
          this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id,
          this.activePhaseType,
          this.phaseType
        )
        if (this.$store.state.campaign.taskId == null) {
          this.$store.commit('campaign/setTaskId', quotation.task_id)
        }
        this.quotationDetail = quotation.vendor_price.map(o => {
          return {
            ...o,
            tableData: o.vendor_price
          }
        })
      } catch (err) {
        throw new Error(err)
      } finally {
        loading.close()
      }
    },
    async getITApproveResult () {
      try {
        const res = await getApproveResult({
          id: this.subFinalScopeId,
          business_type: this.campaign.businessType,
          audit_type: 9
        })
        this.auditData = {
          result: res.status,
          remark: res.comment
        }
      } catch (err) {
        throw new Error(err)
      }
    },
    async submit () {
      const validateResult = await this.$refs.audit.$validator.validate()
      if (!validateResult) return
      const loading = this.$loading()
      const params = {
        sub_final_scope_id: this.subFinalScopeId,
        approve_type: 4, // 审核类型 1：FinalScope 2：报价 3：SpotPlan
        business_type: this.$store.state.campaign.businessType,
        approve_result: this.auditData.result,
        remark: this.auditData.remark,
        task_name: this.$store.state.campaign.taskName,
        campaign_id: this.$store.state.campaign.id,
        servlet_path: this.$route.path,
        task_id: this.$store.state.campaign.taskId
      }

      try {
        await approveFinalReport(params)
        this.$message.success(this.$t('提交成功'))
        this.$router.push('/campaign/process')
      } catch (err) {
        throw new Error(err)
      } finally {
        loading.close()
      }
    }
  }
}
</script>
